import { useCallback } from 'react';

export type UseSearchFunction = <T>(search: string, index: string, source: Array<T>) => Array<T>;

export default function useSearch(): UseSearchFunction {
  const search = useCallback(<T>(search: string, index: string, source: Array<T>): Array<T> => {
    source = JSON.parse(JSON.stringify(source));
    const response = source.filter(item => {
      let searched = String((item as Record<string, unknown>)[index]);
      searched = searched
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      return searched.indexOf(search.toLowerCase()) !== -1;
    });

    return response;
  }, []);

  return search;
}
